import { faTriangleExclamation } from '@awesome.me/kit-eee5f32034/icons/classic/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from '@inertiajs/react';
import { ErrorBoundary } from '@onwardtravelsolutions/package-react/Components';
import { Notice } from '@onwardtravelsolutions/package-react/Types';
import Layout from '../Layout';
import Section from '../Section';

type AppErrorBoundaryProps = {
    children: React.ReactNode;
    notice?: Notice;
};

export default function AppErrorBoundary({ children }: AppErrorBoundaryProps) {
    const Fallback = (
        <Layout>
            <Section id='Error' className='pt-18 lg:pt-28'>
                <div className='py-12 lg:py-20 w-full max-w-full prose-h2:text-3xl prose-h2:lg:text-4xl text-center prose'>
                    <FontAwesomeIcon
                        icon={faTriangleExclamation}
                        className='text-error text-6xl'
                    />
                    <h3 className='capitalize'>
                        An unknown error has occurred
                    </h3>
                    <p>
                        Please return to the{' '}
                        <Link
                            href='/'
                            title='Onward Travel Solutions Ltd Homepage'
                        >
                            Homepage
                        </Link>{' '}
                        or{' '}
                        <Link
                            href='/drivers'
                            title="Onward Travel Solutions Driver's Information"
                        >
                            Driver's Page
                        </Link>
                        .
                    </p>
                </div>
            </Section>
        </Layout>
    );

    return <ErrorBoundary fallback={Fallback}>{children}</ErrorBoundary>;
}
